import { h } from "preact";

import Link from "../../../../foundation/router/Link";
import IconNotifications from "../../Icons/IconNotifications";
import OnlyIconButton, { OnlyIconButtonProps } from "../../OnlyIconButton";

import styles from "./NotificationsButton.module.css";

type InheritedOnlyIconButtonProps = Pick<OnlyIconButtonProps, "activated" | "onClick">;

interface Props extends InheritedOnlyIconButtonProps {
    class?: string;
    hasUnread?: boolean;
    backLink?: string;
    backLabel?: string;
}

function NotificationsButton({
    class: cssClass,
    hasUnread,
    backLink = "",
    backLabel,
    activated,
    onClick
}: Props) {
    return (
        <Link to={backLink} back={backLabel} class={cssClass}>
            <div class={styles.notificationsButtonWrapper}>
                <OnlyIconButton
                    class={styles.notificationsButton}
                    icon={IconNotifications}
                    selected={hasUnread}
                    activated={activated}
                    onClick={onClick}/>
                {hasUnread && <div class={styles.unreadBadge}/>}
            </div>
        </Link>
    );
}

export default NotificationsButton;
